module.exports = __webpack_public_path__ + "img/withdraw 1.79643dc1.svg";